import axios from "axios";
import { ip_back } from "../../config";

const headers = () => ({
  headers: { Authorization: localStorage.getItem("token") },
});

export const SCHEMA_KEYS = [
  "court_coupe",
  "long_coupe",
  "long_rapide",
  "court_lateral",
  "long_varie",
];

export const SCHEMA_NAMES = {
  court_coupe: { en: "Short backspin", fr: "Court coupé" },
  long_coupe: { en: "Long backspin", fr: "Long coupé" },
  long_rapide: { en: "Long fast", fr: "Long rapide" },
  court_lateral: { en: "Short sidespin", fr: "Court latéral" },
  long_varie: { en: "Long mixed", fr: "Long varié" },
};

export function schemaLabel(key, lang = "en") {
  const row = SCHEMA_NAMES[key];
  if (!row) return key || "";
  const short = String(lang || "en").slice(0, 2);
  return row[short] || row.en || key;
}

export function schemaKeyFromExercise(exercise) {
  if (!exercise) return null;
  const nested = exercise.exercise || exercise.tbl_exercise || exercise;
  const direct =
    nested.schema_key ||
    exercise.schema_key ||
    nested.schema?.schema_key ||
    null;
  if (direct) return direct;
  const blob = [
    nested.ex_name,
    nested.ex_name_en,
    nested.ex_name_fr,
    nested.ex_objective_en,
    nested.ex_objective_fr,
    exercise.ex_name,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (/court.?lateral|short.?sidespin/.test(blob)) return "court_lateral";
  if (/long.?varie|long.?mixed/.test(blob)) return "long_varie";
  if (/long.?rapide|long.?fast/.test(blob)) return "long_rapide";
  if (/court.?coupe|cut short|short.?backspin/.test(blob)) return "court_coupe";
  if (/long.?coupe|long.?backspin/.test(blob)) return "long_coupe";
  return null;
}

export async function fetchTacticalLibrary() {
  const res = await axios.get(`${ip_back}api/tactical/library`, headers());
  return res.data?.data || res.data;
}

export async function fetchTacticalPatterns() {
  const res = await axios.get(`${ip_back}api/tactical/patterns`, headers());
  return res.data?.data || [];
}

export async function createTacticalPattern(payload) {
  const res = await axios.post(`${ip_back}api/tactical/patterns`, payload, headers());
  return res.data?.data;
}

export async function updateTacticalPattern(schemaKey, payload) {
  const res = await axios.patch(
    `${ip_back}api/tactical/patterns/${encodeURIComponent(schemaKey)}`,
    payload,
    headers()
  );
  return res.data?.data;
}

export async function fetchScouts() {
  const res = await axios.get(`${ip_back}api/tactical/scouts`, headers());
  return res.data;
}

export async function saveScout(payload) {
  const res = await axios.post(`${ip_back}api/tactical/scouts`, payload, headers());
  return res.data?.data;
}

export async function fetchScout(scoutId) {
  const res = await axios.get(`${ip_back}api/tactical/scouts/${scoutId}`, headers());
  return res.data?.data;
}

export async function proposeGamePlan(payload) {
  const res = await axios.post(`${ip_back}api/tactical/game-plans`, payload, headers());
  return res.data?.data;
}
